const errors = {
  BARCODE_ALREADY_EXIST: 'This bar_code already exists in your inventory.',
  NO_USER_FOUND: 'No user found.',
  USERNAME_PASSWORD_INCORRECT: 'The username or password is incorrect.',
  INVALID_INVENTORY: 'Invalid inventory',
}

export default errors